import { ContentType } from "../../enums/contentStack.js";
import { getConfigurationSettingByDeveloperKey } from "../../services/content/business.lib.js";
import { inventoryService } from "../../services/inventoryService/index.js";
import { normalizeProductApi } from "../../services/productService/normalize.js";
import { normalizeLwData } from "../../services/searchService/LucidWorks/normalizeLwData.js";
import { getProductTileConfigData } from "../../components/Product/ProductTileV2/ContentStack/index.js";
const getProductTileContentStackConfigData = async (locale) => {
  const productTileConfigData = await getProductTileConfigData(true, locale);
  return {
    productTileConfigData
  };
};
const getAddToListContentStackData = async (locale) => {
  const addToListContentStackData = await getConfigurationSettingByDeveloperKey(
    ContentType.ModuleSettings,
    "add_to_list_popup",
    locale
  );
  return {
    addToListContentStackData
  };
};
const getInventoryServiceAndNormalizedProductApi = async (abortSignal, inventoryItemNumbers, inventoryApiConfig, cookieContext, inventoryAware, productApiResponseData, configData, isSignedIn, lwData) => {
  const fetchParsedProductData = async () => {
    var _a;
    let inventoryResponseData;
    if (inventoryAware) {
      const inventoryResponse = await inventoryService(
        inventoryItemNumbers,
        inventoryApiConfig,
        abortSignal,
        cookieContext
      );
      if (!(inventoryResponse == null ? void 0 : inventoryResponse.ok)) {
        console.error("Inventory Api failed", inventoryResponse);
      } else {
        inventoryResponseData = await inventoryResponse.json();
      }
    }
    const normalizedDataObj = normalizeProductApi(
      { inventoryResponseData, productApiResponseData },
      configData,
      Boolean(isSignedIn),
      cookieContext
    );
    return {
      normalizedData: normalizedDataObj == null ? void 0 : normalizedDataObj[0],
      pdpNavigationUrl: (_a = normalizedDataObj == null ? void 0 : normalizedDataObj[0]) == null ? void 0 : _a.productInfoData.productLinkUrl
    };
  };
  return new Promise((resolve) => {
    var _a;
    if (!lwData) {
      return resolve(fetchParsedProductData());
    } else {
      const lwNormalizedDataObj = (_a = normalizeLwData(
        [lwData],
        configData,
        Boolean(isSignedIn),
        cookieContext
      )) == null ? void 0 : _a[0];
      return resolve({
        normalizedData: lwNormalizedDataObj,
        pdpNavigationUrl: lwNormalizedDataObj == null ? void 0 : lwNormalizedDataObj.productInfoData.productLinkUrl
      });
    }
  });
};
const actionButtonControlsCheck = (requiresDeliveryZipcode, isBusinessDeliverySite, deliveryLocation) => {
  if (isBusinessDeliverySite) {
    return Boolean(deliveryLocation.zipCode);
  }
  return Boolean(!requiresDeliveryZipcode || deliveryLocation.zipCode);
};
const showItemNumberCheck = (itemNumber, showItemNumber, isInformative, isBusinessDeliverySite) => {
  return !!itemNumber && showItemNumber && (isInformative || isBusinessDeliverySite);
};
export {
  actionButtonControlsCheck,
  getAddToListContentStackData,
  getInventoryServiceAndNormalizedProductApi,
  getProductTileContentStackConfigData,
  showItemNumberCheck
};
